<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="contact-details-fi">
    <div v-if="(isEditMode && phonenumber1) || phonenumber1?.value">
      <a
        :href="getTel(phonenumber1?.value)"
        class="contact-details-fi__phone"
        :title="phonenumber1?.value"
      >
        <icon-fi
          class="contact-details-fi__icon"
          icon="phone-call"
          size="1"
        />
        <span
          v-if="isEditMode"
          class="contact-details-fi__line"
          v-html="phonenumber1.editable"
        />
        <span
          v-else
          ref="phonenumber1"
          class="contact-details-fi__line"
          v-html="insertBreaks(phonenumber1.value)"
        />
      </a>
    </div>
    <div v-if="(isEditMode && phonenumber2) || phonenumber2?.value">
      <a
        :href="getTel(phonenumber2?.value)"
        class="contact-details-fi__phone"
        :title="phonenumber2?.value"
      >
        <icon-fi
          class="contact-details-fi__icon"
          icon="phone-call"
          size="1"
        />
        <span
          v-if="isEditMode"
          class="contact-details-fi__line"
          v-html="phonenumber2.editable"
        />
        <span
          v-else
          ref="phonenumber2"
          class="contact-details-fi__line"
          v-html="insertBreaks(phonenumber2.value)"
        />
      </a>
    </div>
    <div
      v-if="(isEditMode && fax) || fax?.value"
      class="contact-details-fi__fax"
    >
      <icon-fi
        class="contact-details-fi__icon"
        icon="printer"
        size="1"
      />
      <span
        v-if="isEditMode"
        class="contact-details-fi__line"
        v-html="fax.editable"
      />
      <span
        v-else
        ref="fax"
        class="contact-details-fi__line"
        v-html="insertBreaks(fax.value)"
      />
    </div>
    <div v-if="(isEditMode && email) || email?.value">
      <a
        :href="getMailto(email?.value)"
        class="contact-details-fi__email"
        :title="email?.value"
      >
        <icon-fi
          class="contact-details-fi__icon"
          icon="mail"
          size="1"
        />
        <span
          v-if="isEditMode"
          class="contact-details-fi__line"
          v-html="email.editable"
        />
        <span
          v-else
          ref="email"
          class="contact-details-fi__line"
          v-html="insertBreaks(email.value)"
        />
      </a>
    </div>
  </div>
  <!-- eslint-enabled vue/no-v-html -->
</template>

<script>
import { IconFi } from 'atoms';
import { getMailToHref, getTelHref } from 'utils/linkHelper';

export default {
  name: 'ContactDetailsFi',
  components: {
    IconFi,
  },
  props: {
    email: {
      type: Object,
      default: () => ({}),
    },
    fax: {
      type: Object,
      default: () => ({}),
    },
    phonenumber1: {
      type: Object,
      default: () => ({}),
    },
    phonenumber2: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    insertBreaks(value = '') {
      let html = value
        .trim()
        .replace(
          / *\/ *| +/g,
          (match) => `</span>&#8203;${match}&#8203;<span class="contact-details-fi__line-item">`,
        );
      if (html.includes('@')) {
        html = html.replace(/ /g, '');
        html = value.replace(
          /@/,
          () => '</span>&#8203;<span class="contact-details-fi__line-item">@',
        );
      }

      return `<span class="contact-details-fi__line-item">${html}</span>`;
    },
    getTel(tel) {
      return getTelHref(tel);
    },
    getMailto(mail) {
      return getMailToHref(mail);
    },
  },
};
</script>

<style scoped lang="scss">
@import './contact-details-fi';
</style>
